var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppSelect", {
    attrs: {
      "get-api-fn": _vm.getPage,
      "search-key": _vm.searchKey,
      value: _vm.defaultTearchId,
      label: _vm.value,
      props: _vm.labelProps,
      placeholder: _vm.placeholder,
      params: _vm.params,
    },
    on: { selected: _vm.selected },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }